import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class PlayerView extends Vue {
  @Prop() participant;
  @Prop() participantHand;
  @Prop() participantCamera;
  @Watch('participantCamera', { immediate: true, deep: true })
  onParticipantCamera(val, oldVal) {
    if(!val){
      this.participant.videoTrack.play(`${this.participant.uid}`);
    }
  }
  isAudio = false;
  mounted() {
    this.$nextTick(function() {
      if (this.participant && !this.participant.videoTrack.isPlaying) {
        this.participant.videoTrack.play(
          `${this.participant.uid}`,
          { fit: "cover" },
          err => {
            if (err && err.status !== "aborted") {
              console.warn("trigger autoplay policy");
            }
          }
        );
      }
    });
  }
  destroyed() {
    if (this.participant) {
      if (this.participant.videoTrack?.isPlaying) {
        this.participant.videoTrack.stop();
      }
      this.participant.videoTrack.close();
    }
  }
  disableAudio() {
    this.isAudio = !this.isAudio;
    const participantAudio = {
      uid: this.participant.uid,
      isAudio: !this.isAudio,
      isHand: false,
    }
    this.$emit("setAudioParticipant", participantAudio);
    if(this.isAudio){
      this.participant.audioTrack?.play();
    } else {
      this.participant.audioTrack?.stop();
    }
  }
}
